export const SELECTION_KEY = 'assign-user-entitlements';

export {
    NO_ASSIGNED_ENTITLEMENT_TITLE,
    NO_ASSIGNED_ENTITLEMENT_DESCRIPTION,
} from 'src/modules/entitlements/constants';
